import { FC } from "react";
import { Column, ScrollRow } from "../containers";
import { ColorPickerProps } from "./types";
import { Heading } from "../typography";
import { useThemeStore } from "../../stores";
import { AlignItems } from "../containers/types";
import { COLOR_PICKER_COLORS } from "./data";

const ColorPicker: FC<ColorPickerProps> = ({
  label,
  setValue,
  value,
  props,
  className = "",
  style = {},
}) => {
  const theme = useThemeStore((s) => s.theme);
  return (
    <Column
      alignItems={AlignItems.Start}
      style={{ width: "100%", ...style }}
      props={props}
      className={className}
    >
      <Heading size={16} color={theme.textOnOverlay}>
        {label}
      </Heading>
      <ScrollRow gap={10} height={50}>
        {COLOR_PICKER_COLORS.map((color) => {
          let borderColor = value === color ? theme.primary : color;
          return (
            <div
              key={color}
              style={{
                background: color,
                borderRadius: "50%",
                width: 24,
                height: 24,
                border: `2px solid ${borderColor}`,
                cursor: "pointer",
              }}
              onClick={() => setValue(color)}
            ></div>
          );
        })}
      </ScrollRow>
    </Column>
  );
};

export default ColorPicker;
